/* eslint-disable @typescript-eslint/no-explicit-any */
import { DeepPartial } from "../@types/DeepPartial";

export const mergeDeep = <T>(original: T, objects: DeepPartial<T>): T => {
  if (typeof objects !== "object") return original;
  if (Object.keys(objects).length === 0) return original;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const clone: T = JSON.parse(JSON.stringify(original));
  Object.entries(objects).forEach(([key, value]) => {
    if (
      typeof value === "object" &&
      value !== null &&
      Object.prototype.hasOwnProperty.call(clone, key)
    ) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      clone[key as keyof T] = mergeDeep(
        clone[key as keyof T] as T,
        value,
      ) as any;
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      clone[key as keyof T] = value as any;
    }
  });
  return clone;
};
